import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import { getAdminUsers } from '../api';

const AdminDashboard = () => {
  const [users, setUsers] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await getAdminUsers();
        setUsers(response.data);
      } catch (err) {
        setError("Failed to fetch user data. Check backend logs for details.");
        console.error("Admin dashboard fetch error:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-900 text-gray-200">
        <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }
  
  return (
    <div className="flex min-h-screen bg-gray-900 text-gray-200 font-sans">
      <Sidebar user={{ email: "Admin", role: "admin" }} onSignOut={() => {}} />
      <div className="flex-1 p-8 overflow-y-auto">
        <header className="flex justify-between items-center mb-8">
          <h2 className="text-3xl font-bold text-white">Admin Dashboard</h2>
        </header>

        {error && <div className="p-4 mb-4 text-sm text-red-700 bg-red-100 rounded-lg">{error}</div>}

        <div className="bg-gray-800 rounded-xl shadow-xl p-6 border border-gray-700">
          <h3 className="text-2xl font-semibold mb-4 text-white">All Users</h3>
          {users.length > 0 ? (
            <div className="space-y-6">
              {users.map(user => (
                <div key={user.id} className="bg-gray-700 p-4 rounded-lg border border-gray-600">
                  <p className="font-bold text-lg text-white mb-2">User: {user.email} <span className="text-sm text-gray-400">({user.role})</span></p>
                  <p className="text-sm text-gray-500 mb-4">User ID: {user.id}</p>

                  <div className="mb-4">
                    <h4 className="font-semibold text-gray-300">Cameras</h4>
                    {user.cameras.length > 0 ? (
                      <ul className="list-disc list-inside ml-4 space-y-1 text-sm text-gray-400">
                        {user.cameras.map(cam => (
                          <li key={cam.id}>
                            <span className="font-medium text-white">{cam.name}</span>: {cam.rtsp_url} ({cam.interval}s)
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <p className="text-gray-500 text-sm">No cameras for this user.</p>
                    )}
                  </div>

                  <div>
                    <h4 className="font-semibold text-gray-300">Recent Alerts</h4>
                    {user.alerts.length > 0 ? (
                      <ul className="list-disc list-inside ml-4 space-y-1 text-sm text-gray-400">
                        {user.alerts.map(alert => (
                          <li key={alert.id}>
                            <span className="font-medium text-white">{new Date(alert.timestamp._seconds * 1000).toLocaleString()}</span>: {alert.ai_response}
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <p className="text-gray-500 text-sm">No recent alerts for this user.</p>
                    )}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-gray-500 text-sm">No users found.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;